import { render, staticRenderFns } from "./BaseDragAndDrop.vue?vue&type=template&id=72342cd9&scoped=true&"
import script from "./BaseDragAndDrop.vue?vue&type=script&lang=js&"
export * from "./BaseDragAndDrop.vue?vue&type=script&lang=js&"
import style0 from "./BaseDragAndDrop.vue?vue&type=style&index=0&id=72342cd9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72342cd9",
  null
  
)

export default component.exports